import { Printer } from 'lucide-react';
import { Button } from '../primitives/Button.js';
import { Dialog } from '../primitives/Dialog.js';
import { Kbd } from '../primitives/Kbd.js';
import './shell.css';

export interface ShortcutEntry {
  id: string;
  label: string;
  keys: readonly string[];
  /** Keys pressed one after another (G then S) rather than together. */
  sequence?: boolean;
}

export interface ShortcutSection {
  id: string;
  title: string;
  shortcuts: readonly ShortcutEntry[];
}

export interface ShortcutSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** From the shell's single shortcut registry (global first, then this screen). */
  sections: readonly ShortcutSection[];
  screenName?: string;
}

/** `?` sheet: every shortcut for the current screen, printable (BUILD-PLAN 3.6). */
export function ShortcutSheet({ open, onOpenChange, sections, screenName }: ShortcutSheetProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      size="lg"
      title="Keyboard shortcuts"
      description={screenName ? `Global shortcuts and those for ${screenName}.` : undefined}
      className="vel-shortcuts-dialog"
      footer={
        <Button leadingIcon={<Printer size={14} />} onClick={() => window.print()}>
          Print
        </Button>
      }
    >
      <div className="vel-shortcuts">
        {sections.map((s) => (
          <section key={s.id} className="vel-shortcuts__section">
            <h4 className="vel-shortcuts__title">{s.title}</h4>
            <dl className="vel-shortcuts__list">
              {s.shortcuts.map((k) => (
                <div key={k.id} className="vel-shortcuts__row">
                  <dt>{k.label}</dt>
                  <dd>
                    <Kbd keys={k.keys} sequence={k.sequence ?? false} />
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
